import React, { Dispatch, Fragment, SetStateAction, useEffect, useState } from 'react';
import '../../../../../assets/scss/preview.css';
import { safObjectHelper } from '../../../../../utils/SafObjectHelper.ts';
import { companyApi } from '../../../../../modules';
import { codeApi } from '../../../../../api/code.api.ts';

interface IProps {
  ref?: any;
  formCode?: string;
  section?: any;
  data: any;
}

const View = (props: IProps) => {
  const [companyName, setCompanyName] = useState<any>();

  useEffect(() => {
    if (!props.data?.companyId) return;
    companyApi.getCompanyDetail({ companyId: props.data.companyId }).then((res) => {
      setCompanyName(res.resultObject.companyName);
    });
  }, [props.data?.companyId]);
  return (
    <div>
      <div className={'preview-row preview-top-border'}>
        <div className={'preview-col preview-label saf-bg-white'}>Date of Issue</div>
        <div className={'preview-col preview-value saf-td-center'}>
          {safObjectHelper.formatDate(props.data?.permitDate)}
        </div>
        <div className={'preview-col preview-label saf-bg-white'}>SUBCONTRACTOR</div>
        <div className={'preview-col preview-value saf-td-center'}>{props.data?.subcontractor}</div>
      </div>
      <div className={'preview-row preview-top-border'}>
        <div className={'preview-col preview-label saf-bg-white'}>Method of Excavation</div>
        <div className={'preview-col preview-label saf-bg-white'}>Manual</div>
        <div className={'preview-col preview-label saf-bg-white'} style={{ fontSize: '0' }}>
          <input
            type={'checkbox'}
            className={'preview-checkbox'}
            checked={props.data?.excavation === 'manual'}
            readOnly
          />
        </div>
        <div className={'preview-col preview-label saf-bg-white'}>Mechanical</div>
        <div className={'preview-col preview-label saf-bg-white'} style={{ fontSize: '0' }}>
          <input
            type={'checkbox'}
            className={'preview-checkbox'}
            checked={props.data?.excavation === 'mechanical'}
            readOnly
          />
        </div>
        <div className={'preview-col preview-label saf-bg-white'}>Performing Authority</div>
        <div className={'preview-col preview-value'}></div>
      </div>
      <div className={'preview-row preview-top-border'}>
        <div className={'preview-col preview-label saf-bg-white'}>
          Task Description & Excavation Dimension (Length x Width x Depth)
        </div>
        <div className={'preview-col preview-value'}></div>
      </div>
      <div className={'preview-row preview-top-border'}>
        <div className={'preview-col preview-value'} style={{ height: '5rem' }}>
          {props.data?.description}
        </div>
      </div>
    </div>
  );
};

export default View;
